// extracted by mini-css-extract-plugin
export default {"generalAccess":"SharePrivacy_generalAccess__m2ys+","sectionLabel":"SharePrivacy_sectionLabel__sqbaw"};